<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal :title="props.detailData.nickname + '限制列表'" width="80%" :open="true" :confirmLoading="state.loading"
        :maskClosable="false" @ok="onFormSubmit" @cancel="cancel" :footer="null">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form>
                    <a-row :gutter="48">
                        <a-col :md="6" :sm="24">
                            <a-form-item label="代理商">
                                <a-input v-model:value="queryParam.nickname" placeholder="代理商花名或手机号"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="类型" name="type">
                                <a-select allow-clear mode="multiple" v-model:value="queryParam.type" placeholder="请选择">
                                    <a-select-option :value="1">转让余额</a-select-option>
                                    <a-select-option :value="2">直接提现</a-select-option>
                                    <a-select-option :value="3">微信红包</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="创建时间">
                                <BetweenTimePick v-model:value="queryParam.between_time"></BetweenTimePick>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="备注">
                                <a-input v-model:value="queryParam.nickname" placeholder="备注"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="loadData">查询</a-button>
                                <a-divider type="vertical"></a-divider>
                                <a-config-provider :theme="{
                                    token: {
                                        colorPrimary: '#00b96b', // 替换成你想要的颜色
                                    },
                                }">
                                    <a-button type="primary" @click="handleAdd">新增限制</a-button>
                                </a-config-provider>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
                @change="onChange" rowKey="id">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex == 'status'">
                        <a-tag color="green" v-if="record.status == 1">限制</a-tag>
                        <a-tag color="gray" v-if="record.status == 2">解除限制</a-tag>
                    </template>
                    <template v-else-if="column.dataIndex == 'platform_id'">
                        {{ getPlatformNamesStr(record.platform_id) }}
                    </template>
                    <template v-else-if="column.dataIndex == 'main_type'">
                        {{ getSubjectTypeLabels(record.main_type).join('、') || '未限制' }}
                    </template>
                    <template v-else-if="column.dataIndex == 'is_ybr'">
                        {{ getTaxIdentityLabels(record.is_ybr).join('、') || '未限制' }}
                    </template>
                    <template v-else-if="column.dataIndex == 'business_type'">
                        {{ getEntryTypeLabels(record.business_type).join('、') || '未限制' }}
                    </template>
                    <template v-else-if="column.dataIndex == 'registration_type'">
                        {{ getRegisterTypeLabels(record.registration_type).join('、') || '未限制' }}
                    </template>
                    <template v-else-if="column.dataIndex == 'is_warning'">
                        <a-tag :color="record.is_warning == 1 ? 'orange' : 'green'">
                            {{ record.is_warning == 1 ? '是' : '否' }}
                        </a-tag>
                    </template>
                    <template v-else-if="column.dataIndex === 'expire_time'">
                        {{ record.expire_time || '永久' }}
                    </template>
                    <template v-else-if="column.dataIndex === 'operate'">
                        <a @click="handleEdit(record)" v-if="record.status == 1">编辑</a>
                        <a-divider type="vertical" />
                        <a-popconfirm title="确定解除限制?" placement="left" @openChange="(e) => { }"
                            @confirm="stopRestrict(record)">
                            <a style="color: red;">解除</a>
                        </a-popconfirm>
                    </template>
                </template>
            </a-table>
        </a-card>
        <RestrictForm v-if="state.showCreate" :detailData="state.detailData" :userInfo="props.detailData"
            @cancel="oncancel" @ok="onOk">
        </RestrictForm>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, handleError } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import BetweenTimePick from '@/components/base/BetweenTimePick.vue'
import RestrictForm from './RestrictForm.vue'
import { getPlatformLabel, getPlatformLabels, getPlatformNamesStr } from '@/utils/dictUtils'
const emit = defineEmits(['ok', 'cancel'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const columns = [
    {
        title: '代理商',
        dataIndex: 'nickname',
    },
    {
        title: '限制状态',
        dataIndex: 'status'
    },
    {
        title: '限制平台',
        dataIndex: 'platform_id',
    },
    {
        title: '限制主体类型',
        dataIndex: 'main_type',
    },
    {
        title: '限制税务身份',
        dataIndex: 'is_ybr',
    },
    {
        title: '限制入驻类型',
        dataIndex: 'business_type',
    },
    {
        title: '限制注册类型',
        dataIndex: 'registration_type',
    },
    {
        title: '警告',
        dataIndex: 'is_warning',
    },
    {
        title: '原因',
        dataIndex: 'reason',
        ellipsis: true,
    },
    {
        title: '限制时间',
        dataIndex: 'expire_time',
    },
    {
        title: '创建时间',
        dataIndex: 'created_at',
    },
    {
        title: '操作',
        dataIndex: 'operate',
        width: 200
    }
]
interface state {
    loading: boolean
    detailData: object
    showCreate: boolean
}
const state = reactive<state>({
    loading: false,
    detailData: {},
    showCreate: false
})
let queryParam = reactive<any>({
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
})
const loadData = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/setRestrict/list',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize, user_id: props.detailData.id }, queryParam)
    }
    baseService(requestParam).then((res) => {
        state.loading = false
        pagination.total = res.data.total_records
        dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
    })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
const onFormSubmit = () => {
    emit('cancel')
}
const cancel = () => {
    emit('ok')
}
//添加和编辑
const handleAdd = () => {
    state.detailData = {
        'user_id': props.detailData.id
    }
    state.showCreate = true
}
const handleEdit = (record) => {
    state.detailData = record
    state.showCreate = true
}
const oncancel = () => {
    state.showCreate = false
}
const onOk = () => {
    state.showCreate = false
    loadData()
}
const stopRestrict = (record) => {
    let requestParam = {
        url: '/admin/setRestrict/stop',
        method: 'post',
        data: {
            id: record.id,
            reason: '手动解除限制'
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
const subjectTypeMap: Record<number, string> = {
    1: '公司',
    2: '个体户',
    3: '个人独资企业',
    4: '合伙企业'
}

const taxIdentityMap: Record<number, string> = {
    1: '一般纳税人',
    2: '小规模纳税人'
}

const entryTypeMap: Record<number, string> = {
    1: '设立',
    2: '同区迁入',
    3: '跨区迁入'
}

const registerTypeMap: Record<number, string> = {
    1: '包注册',
    2: '裸地址'
}

const getSubjectTypeLabels = (keys: number[]) => (keys || []).map(k => subjectTypeMap[k] || k)
const getTaxIdentityLabels = (keys: number[]) => (keys || []).map(k => taxIdentityMap[k] || k)
const getEntryTypeLabels = (keys: number[]) => (keys || []).map(k => entryTypeMap[k] || k)
const getRegisterTypeLabels = (keys: number[]) => (keys || []).map(k => registerTypeMap[k] || k)
</script>
<style lang="less" scoped></style>
